import { LoadingCard } from "../../../../../../../_metronic/elements/Loading";
import { useViewAmbientContext } from "./AmbientsContext";
import NoAmbient from "./NoAmbient";
import CreatingAmbient from "./CreatingAmbient";
import ViewAmbient from "./ViewAmbient";
import { useTranslation } from "react-i18next";
import {useEffect, useRef} from "react";
import {openAlert} from "../../../../../../../_metronic/elements/NotificationAlert";

export const Ambients = () => {
    const { t } = useTranslation();
    const { ambientSectionState, ambientSummary } = useViewAmbientContext();
    const notifiedFailures = useRef({});
    const failureSnapshotReady = useRef(false);

    useEffect(() => {
        if (ambientSectionState === "loading") return;
        const failed = {
            historical: ambientSummary.hasFailedHistoricalAmbient,
            image: ambientSummary.hasFailedImageAmbient,
            historicalHd: ambientSummary.hasFailedHistoricalHdJob,
            imageHd: ambientSummary.hasFailedImageHdJob,
        };
        // Persisted failures belong to an earlier attempt. They keep the create
        // actions available, but must not replay a toast every time the user
        // returns to this tab. Notify only failures that appear after the
        // initial loaded snapshot (for example, a job that was processing and
        // fails while this view is open).
        if (!failureSnapshotReady.current) {
            notifiedFailures.current = Object.fromEntries(
                Object.entries(failed).map(([type, isFailed]) => [type, Boolean(isFailed)])
            );
            failureSnapshotReady.current = true;
            return;
        }
        let hasNewFailure = false;
        Object.entries(failed).forEach(([type, isFailed]) => {
            if (isFailed && !notifiedFailures.current[type]) hasNewFailure = true;
            notifiedFailures.current[type] = Boolean(isFailed);
        });
        if (hasNewFailure) {
            openAlert(
                "danger",
                t("ambient:view.messages.creation_failed_title", {defaultValue: "No se pudo crear la ambientación"}),
                t("ambient:view.messages.creation_failed_message", {defaultValue: "Podés intentarlo nuevamente."}),
            );
        }
    }, [
        ambientSectionState,
        ambientSummary.hasFailedHistoricalAmbient,
        ambientSummary.hasFailedImageAmbient,
        ambientSummary.hasFailedHistoricalHdJob,
        ambientSummary.hasFailedImageHdJob,
        t,
    ]);

    if (ambientSectionState === "loading") {
        return <LoadingCard />
    }

    const shouldShowExistingAmbients =
        ambientSummary.hasHistoricalAmbient || ambientSummary.hasHistoricalHdAmbient ||
        ambientSummary.hasImageAmbient || ambientSummary.hasImageAmbientHd;
    const hasImageAmbientProcessing =
        ambientSummary.isImageAmbientProcessing || ambientSummary.isImageHdAmbientProcessing;
    const shouldShowHistoricalCreate =
        !hasImageAmbientProcessing && (
            (!ambientSummary.hasHistoricalAmbient && !ambientSummary.isHistoricalAmbientProcessing) ||
            (!ambientSummary.hasHistoricalHdAmbient && !ambientSummary.isHistoricalHdAmbientProcessing)
        );

    return (
        <>
            {ambientSectionState === "processing" && <CreatingAmbient />}
            {shouldShowHistoricalCreate && <NoAmbient />}
            {shouldShowExistingAmbients && <ViewAmbient />}
            {ambientSectionState === "empty" && !shouldShowHistoricalCreate && <NoAmbient />}
        </>
    )
};
